export default "__VITE_ASSET__Cakv5ouV__"